import { BackgroundImage } from 'platform-components';
import React from 'react';

interface Props extends React.ComponentProps<typeof BackgroundImage> {
    backgroundColor?: string | null;
}

import './course-container-banner__cover.scss';

export const CourseContainerBannerCover = (props: Props) => {
    const { backgroundColor } = props;

    const containerStyle = {
        backgroundColor: backgroundColor ? backgroundColor : undefined,
    };

    return (
        <div className="course-container-banner__cover-container" style={containerStyle}>
            <BackgroundImage
                mix={'course-container-banner__cover'}
                objectFit="contain"
                objectPosition="center left"
                {...props}
            />
        </div>
    );
};
